import { createFileRoute, Outlet, redirect } from '@tanstack/react-router';

import { ensureIdentity } from '../../../features/auth/useAuth';
import { ResumeSessionBanner } from '../../../features/session/ResumeSessionBanner';
import { StudioLayout } from '../../../layouts/StudioLayout';

/**
 * Spec 12.1: the studio requires the `facilitator` role — and spec 10.7 gives
 * `platform_admin` everything a facilitator has, so the check is set membership.
 *
 * Spec 10.8: this guard is cosmetic. Every studio procedure is `facilitatorProcedure` on
 * the server, which is the actual enforcement point.
 */
export const Route = createFileRoute('/$lang/studio')({
  beforeLoad: async ({ context, params, location }) => {
    const identity = await ensureIdentity(context.queryClient);

    if (identity === null || identity.isGuest) {
      throw redirect({
        to: '/$lang/login',
        params: { lang: params.lang },
        search: { returnTo: location.pathname },
      });
    }

    if (identity.role !== 'facilitator' && identity.role !== 'platform_admin') {
      throw redirect({ to: '/$lang/app', params: { lang: params.lang } });
    }
  },
  component: StudioArea,
});

function StudioArea(): React.ReactNode {
  const { lang } = Route.useParams();
  return (
    <StudioLayout lang={lang}>
      <ResumeSessionBanner area="studio" lang={lang} />
      <Outlet />
    </StudioLayout>
  );
}
